export const apiConstants = {
  IsTenantAvailable: 'services/app/Account/IsTenantAvailable',
  GetAll: 'AbpUserConfiguration/GetAll',
};
